import { IRowNode } from 'ag-grid-community';
import { ArrowDownIcon } from 'assets/icons/arrow-down';
import { cn } from 'utils';
import { LazyLoadingSelect } from '../lazy-loading-select';
import { FetchOptionsResponse } from 'hooks/useSelectOptions';
import { useCallback, memo } from 'react';
import { EQueryKeys } from 'constants/query-keys';

interface AgGridLazySelectRendererProps<TData> {
  disabled?: boolean;
  defaultValue?: string | ((data: TData) => string);
  fetchOptions: (
    page?: number,
    pageSize?: number,
    searchText?: string
  ) => Promise<FetchOptionsResponse>;
  initOptions?: { label: string; value: string }[];
  value: TData | null | undefined;
  columnId?: string;
  node: IRowNode<TData>;
}

/**
 * This component has TOO MANY api calls issues
 * Avoid using it till we fix
 */
const AgGridLazySelectRenderer = <TData extends object>({
  fetchOptions,
  disabled,
  ...props
}: AgGridLazySelectRendererProps<TData>) => {
  const { columnId, node } = props;

  const handleChange = useCallback(
    (selectedValue: string) => {
      if (columnId) {
        node.setDataValue(columnId, selectedValue);
      }
    },
    [columnId, node]
  );

  return (
    <LazyLoadingSelect
      fetchOptions={fetchOptions}
      onSelect={handleChange}
      onChange={handleChange}
      suffixIcon={<ArrowDownIcon />}
      allowClear={false}
      defaultValue={props.defaultValue}
      value={props.value}
      className={cn(
        'w-full ag-grid-select',
        disabled && 'ag-grid-select-disabled'
      )}
      additionalOptions={props.initOptions}
      size="large"
      disabled={disabled}
      queryKey={columnId + EQueryKeys.LAZY_LOADING_SELECT}
    />
  );
};

export default memo(
  AgGridLazySelectRenderer
) as typeof AgGridLazySelectRenderer;
